/*
 * Inline Report Story button used by the LEGACY (Bootstrap-style) more-menu
 * branch in `part-actions.hbs` and `share-tools.hbs`.
 *
 * This component is NOT used when `IS_REACT_PART_FOOTER_ACTIONS` is on — the
 * React ActionMenu replacement (`PartActionsMore.js`) renders its own report
 * item that mirrors this component. Both open the same
 * `/webview/report/storypart/{partId}` webview route.
 */

import React from "react";
import { useTrans } from "../hooks";
import { openResponsivePopup } from "../helpers";
import Icon from "./Icon";
import PropTypes from "prop-types";

const ReportStoryPart = ({ partId }) => {
  const { trans } = useTrans();

  const handleOnClick = () => {
    openResponsivePopup({
      url: `/webview/report/storypart/${partId}`,
      width: 500,
      height: 700
    });
  };

  return (
    <button className="btn-option" onClick={handleOnClick}>
      <Icon
        iconName="fa-warning"
        color="wp-neutral-2"
        height="20"
        className="pull-left"
      />
      {trans("Report Story")}
    </button>
  );
};

ReportStoryPart.propTypes = {
  partId: PropTypes.string.isRequired
};

export default ReportStoryPart;
